import { render, staticRenderFns } from "./ChatTextButtonImage.vue?vue&type=template&id=10da4402&scoped=true&"
import script from "./ChatTextButtonImage.vue?vue&type=script&lang=js&"
export * from "./ChatTextButtonImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatTextButtonImage.vue?vue&type=style&index=0&id=10da4402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da4402",
  null
  
)

export default component.exports